import { render, staticRenderFns } from "./carrierExPage.vue?vue&type=template&id=1f3ffaf6&scoped=true&"
import script from "./carrierExPage.vue?vue&type=script&lang=js&"
export * from "./carrierExPage.vue?vue&type=script&lang=js&"
import style0 from "./carrierExPage.vue?vue&type=style&index=0&id=1f3ffaf6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f3ffaf6",
  null
  
)

export default component.exports